import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth-guard';
import { AuthGuardSigo } from './core/guards/auth-guard-sigo';

const routes: Routes = [
  // { path: '', loadChildren: './modules/01-home/home.module#HomeModule' , canActivate: [AuthGuard] },
  { path: '', loadChildren: './modules/procedimientos-tupa/procedimientos-tupa.module#ProcedimientosTupaModule', canActivate: [AuthGuard] },
  { path: 'index-bonificacion', loadChildren: './modules/01-home/pages/index-bonificacion/index-bonificacion.module#IndexBonificacionModule', canActivate: [AuthGuard] },
  { path: 'clave', loadChildren: './modules/02-cambio-clave/cambio-clave.module#CambioClaveModule', canActivate: [AuthGuard] },
  { path: 'usuarios', loadChildren: './modules/usuarios/usuarios.module#UsuariosModule', canActivate: [AuthGuard] },
  { path: 'demo', loadChildren: './modules/00-demo/demo.module#DemoModule' },
  { path: 'autorizaciones', loadChildren: './modules/autorizaciones/autorizaciones.module#AutorizacionesModule', canActivate: [AuthGuard] },
  { path: 'bonificaciones', loadChildren: './modules/bonificaciones/bonificaciones.module#BonificacionesModule', canActivate: [AuthGuard] },
  { path: 'procedimientos-tupa', loadChildren: './modules/procedimientos-tupa/procedimientos-tupa.module#ProcedimientosTupaModule', canActivate: [AuthGuard] },
  { path: 'permiso-bonificacion', loadChildren: './modules/permiso-bonificacion/permiso-bonificacion.module#PermisoBonificacionModule', canActivate: [AuthGuard] },
  { path: 'asociar-casilla', loadChildren: './modules/asociar-casilla/asociar-casilla.module#AsociarCasillaModule', canActivate: [AuthGuard] },
  { path: 'bandeja', loadChildren: './modules/bandeja/bandeja.module#BandejaModule', canActivate: [AuthGuardSigo] },
  { path: 'reportes', loadChildren: './modules/reportes/reportes.module#ReportesModule', canActivate: [AuthGuardSigo] },
  { path: 'horarios', loadChildren: './modules/horario/horario.module#HorarioModule', canActivate: [AuthGuardSigo] },
  { path: 'peaje', loadChildren: './modules/peaje/peaje.module#PeajeModule', canActivate: [AuthGuardSigo] },
  { path: 'peaje-caja', loadChildren: './modules/peaje-caja/peaje-caja.module#PeajeCajaModule', canActivate: [AuthGuardSigo] },
  { path: 'asociar-conductor', loadChildren: './modules/asociar-conductor/asociar-conductor.module#AsociarConductorModule', canActivate: [AuthGuard] },
  {
    path: 'configuracion',
    loadChildren: () => import('./modules/configuracion/configuracion.module').then(m => m.ConfiguracionModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tesoreria',
    loadChildren: () => import('./modules/tesoreria/tesoreria.module').then(m => m.TesoreriaModule),
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }




// import { NgModule } from "@angular/core";
// import { Routes, RouterModule } from "@angular/router";
// import { AuthenticationGuard } from "./core/guards/authentication-guard";
// import { SessionRestoreGuard } from "./core/guards/session-restore-guard";
// import { AuthorizationGuard } from "./core/guards/authorization-guard";

// const routes: Routes = [
//   {
//     path: "login",
//     loadChildren: "./modules/login/login.module#LoginModule",
//   },
//   {
//     path: "mi-cuenta",
//     loadChildren: "./modules/mi-cuenta/mi-cuenta.module#MiCuentaModule",
//   },
//   {
//     path: "clave",
//     loadChildren:
//       "./modules/02-cambio-clave/cambio-clave.module#CambioClaveModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "usuarios",
//     loadChildren: "./modules/usuarios/usuarios.module#UsuariosModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "autorizaciones",
//     loadChildren:
//       "./modules/autorizaciones/autorizaciones.module#AutorizacionesModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "bonificaciones",
//     loadChildren:
//       "./modules/bonificaciones/bonificaciones.module#BonificacionesModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "permiso-bonificacion",
//     loadChildren:
//       "./modules/permiso-bonificacion/permiso-bonificacion.module#PermisoBonificacionModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "asociar-casilla",
//     loadChildren:
//       "./modules/asociar-casilla/asociar-casilla.module#AsociarCasillaModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "componente-vehicular",
//     loadChildren:
//       "./modules/componente-vehicular/componente-vehicular.module#ComponenteVehicularModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "empresa-certificadora",
//     loadChildren:
//       "./modules/empresa-certificadora/empresa-certificadora.module#EmpresaCertificadoraModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "bandeja",
//     loadChildren: "./modules/bandeja/bandeja.module#BandejaModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "horarios",
//     loadChildren: "./modules/horario/horario.module#HorarioModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "peaje",
//     loadChildren: "./modules/peaje/peaje.module#PeajeModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "peaje-caja",
//     loadChildren: "./modules/peaje-caja/peaje-caja.module#PeajeCajaModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "asociar-conductor",
//     loadChildren:
//       "./modules/asociar-conductor/asociar-conductor.module#AsociarConductorModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "reportes",
//     loadChildren:
//       "./modules/reportes/reportes.module#ReportesModule",
//     //canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },
//   {
//     path: "",
//     loadChildren: "./modules/01-home/home.module#HomeModule",
//     canActivate: [AuthenticationGuard, SessionRestoreGuard],
//   },
//   {
//     path: "demo",
//     loadChildren: "./modules/00-demo/demo.module#DemoModule",
//     canActivate: [AuthenticationGuard, AuthorizationGuard],
//   },

//   { path: "**", redirectTo: "", pathMatch: "full" },
// ];

// @NgModule({
//   imports: [RouterModule.forRoot(routes)],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {}
